import { render, staticRenderFns } from "./ImageLibraryV2.vue?vue&type=template&id=d3987b68"
import script from "./ImageLibraryV2.vue?vue&type=script&lang=js"
export * from "./ImageLibraryV2.vue?vue&type=script&lang=js"
import style0 from "./ImageLibraryV2.vue?vue&type=style&index=0&id=d3987b68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports